import React, { useEffect, useMemo, useState } from 'react';
import ChannelPicker from './ChannelPicker';
import SideMenu from './SideMenu';
import { translate } from '../Services/translation';

const ChannelPickerTrigger = ({ items }) => {
  const [visible, setVisible] = useState(false);
  const [activeCountry, setActiveCountry] = useState(null);
  useMemo(() => {
    if (items && items.length > 0) {
      setActiveCountry(items.find((item) => item.isSelected));
    }
  }, [items]);
  const header = (
    <>
      <span className="text-medium color-grey-900 bold">
        {translate('channelpicker.title')}&nbsp;
      </span>
    </>
  );
  useEffect(() => {
    console.log(visible);
  }, [visible]);
  return (
    <>
      <button
        className="channel-picker__button text-small text-medium-from-medium lh-2 color-grey-900"
        onClick={() => setVisible(!visible)}
      >
        <img
          src={activeCountry?.channelFlag}
          alt={activeCountry?.channelListName}
        />
        <span>{activeCountry?.channelListName}</span>
      </button>
      <SideMenu
        id="ChannelPicker"
        open={visible}
        header={header}
        className="channel-picker-sidemenu"
        onClosed={() => setVisible(false)}
      >
        <>
          <ChannelPicker items={items} />
        </>
      </SideMenu>
    </>
  );
};

export default ChannelPickerTrigger;
